import { defineStore } from 'pinia';
import { api } from '../api/axios';
import { isAxiosError } from 'axios';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    infoAcces: null,
    listReport: null,
    termsAccepted: false,
  }),
  actions: {
    async login(info) {
      try {
        const { headers } = await api.post('login/user', info);
        localStorage.setItem('token', headers.token);
        return { ok: true, resultado: 'Exitoso' };
      } catch (error) {
        if (isAxiosError(error)) {
          return {
            ok: false,
            message: error.response?.data.detail,
          };
        }
      }
    },

    async code(opt) {
      try {
        const { data, headers } = await api.post('login/otp', {otp:opt});
        localStorage.clear();
        localStorage.setItem('token', headers.token);
        this.infoAcces = data
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Ocurrió un error al enviar el código.' };
      }
    },

    async logout(item) {
      try {
        const { data } = await api.post('login/logout', item);
      
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Ocurrió un error al cerrar sesión.' };
      }
    },

    async pingtoken(item) {
      try {
        const { data } = await api.post('user/pingtokennewuser',{token:item} );
      
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Token invalido favor contactar al administrador.' };
      }
    },

    async crearPassword(item) {
      try {
        const { data } = await api.post('user/completenewuser',item );
      
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Token invalido favor contactar al administrador.' };
      }
    },

    async resetPassword(item) {
      try {
        const { data } = await api.post('user/resetpasscomplete',item );
      
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Token invalido favor contactar al administrador.' };
      }
    },

    async powerBi(item) {
      try {
        const { data } = await api.post('user/getlinkpbi', {idmandato:item } );
      
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Ocurrió un error al obtener el reporte gráfico.' };
      }
    },

    async getReports(item) {
      try {
        const { data } = await api.post('SA/onedrive/vistageneral/getreports',{identificador: item} );
      this.listReport =  data;
        return { ok: true, resultado: data };
      } catch (error) {
        return { ok: false, message: 'Ocurrió un error al obtener el reporte.'  };
      }
    },

    async checkTermsAccepted() {
      try {
        const { data } = await api.get('user/checkterms');
        this.termsAccepted = !!data?.aceptoTerminos;
        return this.termsAccepted;
      } catch (error) {
        // El endpoint aún no existe en el backend: no bloquear el acceso al portal.
        this.termsAccepted = true;
        return true;
      }
    },

    async acceptTerms() {
      try {
        await api.post('user/acceptterms', {});
        this.termsAccepted = true;
        return { ok: true };
      } catch (error) {
        return { ok: false, message: 'Ocurrió un error al aceptar los términos y condiciones.' };
      }
    },

  },
});
